import { render, staticRenderFns } from "./m_header.vue?vue&type=template&id=72ddcc6d&scoped=true&"
import script from "./m_header.vue?vue&type=script&lang=js&"
export * from "./m_header.vue?vue&type=script&lang=js&"
import style0 from "./m_header.vue?vue&type=style&index=0&id=72ddcc6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ddcc6d",
  null
  
)

export default component.exports